import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
@Directive({
  selector: '[ivClickOutSideDirective]'
})
export class ClickOutSideDirective {
  @Output() clickoutside: EventEmitter<any>;
  classNames: String[] = [];
  resiDateRangeClassNames = [
    'mat-mdc-button-touch-target',
    'mat-mdc-focus-indicator',
    'mdc-icon-button',
    'mdc-button__label',
    'mat-calendar',
    'mat-calendar-header',
    'mat-calendar-controls',
    'mat-calendar-table',
    'mat-calendar-body',
    'mat-calendar-body-label',
  ];

  constructor(private elementRef: ElementRef) {
    this.clickoutside = new EventEmitter<any>();
    this.classNames = [
      'mat-select-arrow',
      'mat-select-arrow-wrapper',
      'mat-button-wrapper',
      'mat-select-search-inner',
      'mat-checkbox-layout',
      'mat-option-text',
      'peoplesoft',
      'filter',
      'mat-select-value',
      'mat-focus-indicator',
      'cdk-overlay-container',
      'mdc-list-item__primary-text',
      ...this.resiDateRangeClassNames,
    ];
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const isInsideClicked = this.elementRef.nativeElement.contains(targetElement);
    let clicked = 'outside';
    if (isInsideClicked || (!isInsideClicked && (targetElement?.innerText?.split(' ')[1] === 'selected'
      || this.classNames.includes(targetElement?.parentNode?.className)
      || this.classNames.includes(targetElement?.className) || this.checkIfInsideClassExist(targetElement)))) {
      clicked = 'inside';
    }
    this.clickoutside.emit(clicked);
  }

  checkIfInsideClassExist(ele) {
    let elParentExist = false;
    if (ele?.parentNode?.classList) {
      elParentExist = [...ele?.parentNode?.classList].some(cl => this.classNames.includes(cl));
    }
    return ([...ele?.classList].some(cl => this.classNames.includes(cl)) || elParentExist);
  }
}
